// @flow
import React, { Component } from "react";
import _ from "lodash";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import TransfersRow from "./transfersRow/TransfersRow";
import TransfersBox from "./transfersBox/TransfersBox";
import styles from "../../orders/orderTable/OrderTable.scss";

const TransfersTable = props => {
  const {
    browser,
    view,
    lang,
    data,
    transfersType,
    searchString,
    printCall,
    exportAsn,
    isPrintLoading,
    closeAsn,
    seller,
    isFbn
  } = props;

  const property = Helper.validator(data);

  const transfersList =
    data && !_.isEmpty(data)
      ? data.map((transfers, index) => (
          <TransfersRow
            data={transfers}
            transfersType={transfersType}
            lang={lang}
            searchString={searchString}
            printCall={printCall}
            exportAsn={exportAsn}
            isPrintLoading={isPrintLoading}
            closeAsn={closeAsn}
            seller={seller}
            property={property}
            isFbn={isFbn}
          />
        ))
      : "";

  const transfersBox =
    data && !_.isEmpty(data)
      ? data.map((transfers, index) => (
          <div className={styles.transfersBox}>
            <TransfersBox
              data={transfers}
              transfersType={transfersType}
              lang={lang}
              searchString={searchString}
              printCall={printCall}
              exportAsn={exportAsn}
              isPrintLoading={isPrintLoading}
              closeAsn={closeAsn}
              seller={seller}
              isFbn={isFbn}
            />
          </div>
        ))
      : "";

  return (
    <div className={styles.ctr}>
      {browser && browser.greaterThan.desktop && view === "grid" ? (
        <table className={`${styles.table} ${styles.transfers}`}>
          <thead>
            <tr className={`${styles.row} ${styles.head}`}>
              {property.haveVal("asn_nr") ? (
                <th> {I18n.getText("transfers.asn")} </th>
              ) : (
                ""
              )}
              {property.haveVal("partner_rtv_nr") ? (
                <th> {I18n.getText("transfers.rtv-nr")} </th>
              ) : (
                ""
              )}
              {property.haveQtyVal("qty_expected") ? (
                <th> {I18n.getText("transfers.expected-qty")} </th>
              ) : (
                ""
              )}
              {property.haveQtyVal("qty_sent") ? (
                <th>
                  {I18n.getText(
                    transfersType === 2
                      ? "order-details.units"
                      : "transfers.picked-qty"
                  )}
                </th>
              ) : (
                ""
              )}

              {property.haveQtyVal('qty_recv') ? (
                <th>{I18n.getText("transfers.received-qty")}</th>
              ) : (
                ""
              )}
              {property.haveQtyVal("qty_approved") ||
              property.haveQtyVal("qty_rejected") ||
              property.haveQtyVal("qty_unidentified") ||
              property.haveQtyVal("qty_excess") ? (
                <th>{I18n.getText("transfers.breakdown")}</th>
              ) : (
                ""
              )}

              {property.haveVal("warehouse_code") ? (
                <th>
                  {I18n.getText(
                    transfersType === 2
                      ? "transfers.destination"
                      : "transfers.origin"
                  )}
                </th>
              ) : (
                ""
              )}
              {property.haveVal("warehouse_from") ? (
                <th>{I18n.getText("transfers.origin")}</th>
              ) : (
                ""
              )}
              {property.haveVal("warehouse_to") ? (
                <th>{I18n.getText("transfers.destination")}</th>
              ) : (
                ""
              )}

              {property.haveVal("picked_at") ? (
                <th> {I18n.getText("transfers.picked-at")} </th>
              ) : (
                ""
              )}

              {property.haveVal("received_at") ? (
                <th>{I18n.getText("transfers.received-at")}</th>
              ) : (
                ""
              )}
              {property.haveVal("shipped_at") ? (
                <th>{I18n.getText("transfers.shipped-at")}</th>
              ) : (
                ""
              )}
              {property.haveVal("scheduled_at") ? (
                <th>{I18n.getText("transfers.scheduled-at")}</th>
              ) : (
                ""
              )}
              {property.haveVal("posted_at") ? (
                <th>{I18n.getText("transfers.closed-at")}</th>
              ) : (
                ""
              )}

              {property.haveVal("current_skunique") ? (
                <th>{I18n.getText("transfers.current-sku-u")}</th>
              ) : (
                ""
              )}

              {property.haveVal("zone_code") ? (
                <th>
                  {I18n.getText(
                    "statement-details.finance-view-statement-type"
                  )}
                </th>
              ) : (
                ""
              )}

              {property.haveVal("status") ? (
                <th>{I18n.getText("product-table.status")}</th>
              ) : (
                ""
              )}

              <th />
            </tr>
          </thead>
          <tbody>{transfersList} </tbody>
        </table>
      ) : (
        <div className={styles.boxCtr}>{transfersBox}</div>
      )}
    </div>
  );
};

export default TransfersTable;



// WEBPACK FOOTER //
// ./src/components/transfers/transfersTable/TransfersTable.js